import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { withCustomValidation } from '@bingads-webui-react/validation';
import { ActivityContext } from '@bingads-webui-react/hoc-with-signal';
import { LegacyCallToAction } from './legacy-call-to-action';

const LegacyCallToActionWithCustomValidation = ({
  validationProps, updateValidation, setNewCTACallback, ...restProps
}) => {
  const { data } = validationProps;

  const activity = useContext(ActivityContext);
  const onChange = useCallback((CallToAction, CallToActionValue) => {
    updateValidation([], { CallToAction, CallToActionValue });

    if (activity) {
      activity.signal(`onLegacyCallToActionChange - ${JSON.stringify(CallToAction)}`);
    }
  }, [updateValidation, activity]);

  return (
    <LegacyCallToAction value={data.CallToAction} setNewCTACallback={setNewCTACallback} valueText={data.CallToActionValue || ''} onChange={onChange} {...restProps} />
  );
};

LegacyCallToActionWithCustomValidation.propTypes = {
  validationProps: PropTypes.shape({
    data: PropTypes.shape({
      CallToAction: PropTypes.string,
      CallToActionValue: PropTypes.string,
    }),
  }).isRequired,
  updateValidation: PropTypes.func.isRequired,
  setNewCTACallback: PropTypes.func,
};

LegacyCallToActionWithCustomValidation.defaultProps = {
  setNewCTACallback: null,
};

export const ValidatedLegacyCallToAction = withCustomValidation(LegacyCallToActionWithCustomValidation);
